module.exports = __webpack_public_path__ + "img/auth-right-bg.628d22eb.svg";